// import { NAVIGATION_LINKS } from 'helper/const/navigation';
import React from 'react';
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Image,
  NavDropdown,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import illustration from 'assets/images/banner-illustration.png';
import styles from './header.module.scss';
import RequestDemoButton from './RequestDemoButton';
import useResponsive from 'helper/hooks/useResponsive';

const DROP_LINKS_PROGRAMS = [
  { href: '/csbg', name: 'CSBG' },
  { href: '/liheap', name: 'LIHEAP' },
  { href: '/head-start', name: 'Head Start' },
  { href: '/transportation', name: 'Transportation' },
  { href: '/victim-support-services', name: 'Victim Support Services' },
  // { href: '/nutrition', name: 'Nutrition' },
  { href: '/weatherization', name: 'Weatherization' },
  { href: '/case-management', name: 'Case Management' },
  { href: '/youth-programs', name: 'Youth Programs' },
  { href: '/housing-assistance', name: 'Housing Assistance' },
];

const DROP_LINKS_ADDONS = [
  { href: '/client-kiosk', name: 'Client Kiosk (Client Portal)' },
  { href: '/state-kiosk', name: 'State Kiosk' },
  { href: '/id-card-scanner', name: 'ID Card Scanner' },
  { href: '/custom-survey', name: 'Custom Survey' },
  { href: '/electronic-signature', name: 'Electronic Signature' },
  { href: '/barcode-scanner', name: 'Barcode Scanner' },
  { href: '/campaign-manager', name: 'Campaign Manager' },
  { href: '/auto-dialer', name: 'Auto Dialer & Texter' },
  { href: '/mailing-wizard', name: 'Mailing Wizard' },
];

const DROP_LINKS_RESOURCE = [
  { href: '/case-study', name: 'Case Studies' },
  { href: '/press-release', name: 'Press Releases' },
];

function Header() {
  return (
    <Container>
      <Navigation />
    </Container>
  );
}

export default Header;

function Navigation() {
  return (
    <Navbar collapseOnSelect expand="md" bg="transparent" variant="light">
      <Link to="/">
        <Navbar.Brand>
          <Logo />
        </Navbar.Brand>
      </Link>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link className={styles.navLink} as={Link} to="/">
            Home
          </Nav.Link>
          <NavDropdown
            className={styles.navLink}
            renderMenuOnMount={true}
            // title="Programs"
            title={<DropdownTitle title="Programs" path="/programs" />}
          >
            {DROP_LINKS_PROGRAMS.map((link) => (
              <NavDropdown.Item key={link.name} to={link.href} as={Link}>
                {' '}
                {link.name}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
          <NavDropdown
            className={styles.navLink}
            renderMenuOnMount={true}
            title={<DropdownTitle title="Add-Ons" path="/add-ons" />}
          >
            {DROP_LINKS_ADDONS.map((link) => (
              <NavDropdown.Item key={link.name} as={Link} to={link.href}>
                {' '}
                {link.name}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
          <NavDropdown
            className={styles.navLink}
            renderMenuOnMount={true}
            title="Resources"
          >
            {DROP_LINKS_RESOURCE.map((link) => (
              <NavDropdown.Item key={link.name} as={Link} to={link.href}>
                {' '}
                {link.name}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
          <Nav.Link className={styles.navLink} as={Link} to="/events">
            Events
          </Nav.Link>
          <Nav.Link className={styles.navLink} as={Link} to="/contact-us">
            Contact us
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export function Banner() {
  return (
    <div className={styles.banner}>
      <Container>
        <Row className="align-items-center">
          <Col md={7}>
            <div className={styles.bannerContent}>
              <h1>
                Agency Wide Data Management <br /> And{' '}
                <span> Reporting System </span>
              </h1>
              <p>CSBG, Victim Services, Headstart, Energy and More</p>
              <RequestDemoButton />
            </div>
          </Col>
          <Col
            md={{ span: 5, order: 'last' }}
            sm={{ order: 'first' }}
            xs={{ order: 'first' }}
          >
            <div className={styles.bannerImage}>
              <Image src={illustration} fluid />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

function DropdownTitle({ title, path }) {
  const { isMobile } = useResponsive();
  if (isMobile) {
    return title;
  }
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Link to={path}>{title}</Link>
    </span>
  );
}
